import type { PageLoad } from './$types';
import { routesPagename } from '$lib/services/urls/routesPagename';

export const load = (async (event) => {
	event.depends('loadUser:init');
	await event.parent();

	return {
		pagename: routesPagename.PROFILE_INFORMATION,
	};
}) satisfies PageLoad;
